import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSports } from "modules/sport/hooks";
import { Content } from "./Content";
import { LoaderFullscreen } from "../../modules/core/components";

export const Sport = () => {
  const { sport } = useParams();
  const { sports, isLoaded: isSportsLoaded } = useSports();

  const currentSport = useMemo(() => {
    if (!isSportsLoaded) return;

    return sports.find(({ name }) => name === sport);
  }, [sports, sport, isSportsLoaded]);

  useEffect(() => {
    document.title = `${currentSport?.name === 'icehockey' ? 'ICE HOCKEY' : currentSport?.name.toUpperCase()} | Staidium`;
  }, [currentSport]);

  if (!isSportsLoaded || !currentSport) return <LoaderFullscreen />;
  return <Content sport={currentSport} />;
};
